import http from "./http_common";

class NotificationService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  NotificationCount(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/notification/getCountStatus?${queryString}`);
  }

  NotificationList(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/notification/list/filter?${queryString}`);
  }

  NotificationUpdate(payload) {
    return http.put(`/notification/countstatus/${payload.id}`, payload);
  }
}

export default new NotificationService();
